import { createFromIconfontCN } from '@ant-design/icons';

export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_5009826_bh0llc62srq.js', // 在 iconfont.cn 上生成
});
